/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { RtSystemCategory } from './RtSystemCategory';
import {
    instanceOfRtSystemCategory,
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';

/**
 * @type EquipmentTypeCatalogDtoCategory
 * 
 * @export
 */
export type EquipmentTypeCatalogDtoCategory = RtSystemCategory;


export function EquipmentTypeCatalogDtoCategoryFromJSON(json: any): EquipmentTypeCatalogDtoCategory {
    return EquipmentTypeCatalogDtoCategoryFromJSONTyped(json, false);
}

export function EquipmentTypeCatalogDtoCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentTypeCatalogDtoCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...RtSystemCategoryFromJSONTyped(json, true) };
    return  RtSystemCategoryFromJSONTyped(json, true);
}

export function EquipmentTypeCatalogDtoCategoryToJSON(value?: EquipmentTypeCatalogDtoCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfRtSystemCategory(value)) {
        return RtSystemCategoryToJSON(value as RtSystemCategory);
    }

    return {};
}

/**
 * Check if a given object implements the EquipmentTypeCatalogDtoCategory interface.
 */
export function instanceOfEquipmentTypeCatalogDtoCategory(value: any): value is EquipmentTypeCatalogDtoCategory {
    if (instanceOfRtSystemCategory(value)) return true;
    return false;
}

